// SPDX-License-Identifier: AGPL-3.0-or-later

import {Routes} from '@app/app/Routes';
import Accessibility from '@app/features/accessibility/state/Accessibility';
import RuntimeConfig from '@app/features/app/state/RuntimeConfig';
import {isFeedEnabled} from '@app/features/feed/utils/FeedUtils';
import GuildListState from '@app/features/guild/state/GuildList';

function getFirstAvailableGuildId(): string | null {
	const guilds = GuildListState.guilds;
	for (const guild of guilds) {
		if (!guild.unavailable) {
			return guild.id;
		}
	}
	return null;
}

export function getDirectMessagesFallbackPath(): string {
	const firstGuildId = getFirstAvailableGuildId();
	if (firstGuildId) {
		return Routes.guildChannel(firstGuildId);
	}
	if (Accessibility.showFavorites) {
		return Routes.FAVORITES;
	}
	if (!RuntimeConfig.singleCommunityEnabled) {
		return Routes.DISCOVER;
	}
	return Routes.ME;
}

export function getDefaultLandingPath(): string {
	if (isFeedEnabled()) {
		return Routes.FEED;
	}
	if (RuntimeConfig.directMessagesDisabled) {
		return getDirectMessagesFallbackPath();
	}
	return Routes.ME;
}

// Micup: the first route of a signed-in session. Opening the app lands on the DM home (the PWA start, the desktop
// window, the sign-in fallback); with the feed on it starts there, otherwise Fluxer's last place comes back. Any other
// first route is a direct link and keeps its target.
export function getColdStartRedirect(pathname: string, lastLocation: string | null): string | null {
	if (pathname !== Routes.ME) {
		return null;
	}
	if (isFeedEnabled()) {
		return Routes.FEED;
	}
	return lastLocation && lastLocation !== pathname ? lastLocation : null;
}

export function shouldRedirectAwayFromDirectMessages(pathname: string): boolean {
	if (!RuntimeConfig.directMessagesDisabled) {
		return false;
	}
	return Routes.isDMRoute(pathname);
}
